import styled from 'styled-components'
import PropTypes from 'prop-types'

import { Flex as FlexComponent } from '../../layout/flex'
import { Heading } from '../../typography/heading'
import { Text } from '../../typography/text'
import { NotApplicableIcon } from '../../icons/notApplicable'

const Flex = styled(FlexComponent)`
  height: 525px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`
const NoSearchResults = ({ searchTerm }) => {
  return (
    <Flex>
      <NotApplicableIcon size="large" />
      {searchTerm ? (
        <>
          <Heading level="2">
            Your search for <b>{searchTerm}</b> did not match any records
          </Heading>
          <Text align="center">
            Make sure that the spelling is correct or try adjusting your search.
          </Text>
        </>
      ) : (
        <Heading level="2">There are no results within the selected date range</Heading>
      )}
    </Flex>
  )
}

NoSearchResults.propTypes = { searchTerm: PropTypes.string }

export { NoSearchResults }
